<template>
    <cmpTableWithMenu v-bind:name="name"
                      v-bind:pkColumn="pkColumn"
                      v-bind:fields="fields"
                      v-bind:qryFields="qryFields"
                      v-bind:children="children"
                      v-bind:parent="parent"
                      v-bind:header="header"
                      v-bind:tableFuncs="tableFuncs"
                      v-bind:moreTableFuncs="moreTableFuncs"></cmpTableWithMenu>
</template>

<script>
    import i18n from '@/i18n'
    import cmpTableWithMenu from "@/components/common/cmpTableWithMenu"

    export default {
        components: {
            cmpTableWithMenu
        },
        computed: {
            fields() {
                return [
                    { "key": "Operation", "label": i18n.t('component.operation'), tdClass: 'text-center', thClass: 'text-center' },
                    { "key": "No", "label": "No." },
                    { "key": "UserId", "label": i18n.t('component.UserRole.UserId.label'), sortable: true },
                    { "key": "UserName", "label": i18n.t('component.UserRole.UserName.label'), sortable: true },
                    { "key": "Account", "label": i18n.t('component.UserRole.Account.label'), sortable: true },
                    { "key": "RoleName", "label": i18n.t('component.UserRole.RoleName.label'), sortable: true }
                ]
            },
            qryFields() {
                return [
                    { "key": "UserId", "label": i18n.t('component.UserRole.UserId.label'), input: { type: "textboxSearch", objectName: "User", idField: "UserId", displayField: "Name", qryFields: ["MemberIdOr", "NameOr"], displayFields: ["MemberId", "Name"] } },
                    { "key": "RoleId", "label": i18n.t('component.UserRole.RoleId.label'), input: { type: "select", objectName: "Role", idField: "RoleId", displayField: "RoleName" } },
                ]
            }
            ,
            header() {
                return i18n.t('component.UserRole.lstHeader')
            }
        },
        data() {

            return {
                name: "Login",
                pkColumn: "LoginId",
                children: {},
                parent: {},
                tableFuncs: ['rec', 'copyNew', 'edit', 'delete'],
                moreTableFuncs: []
            };
        }
    }
</script>